import { Spinner } from "@/components/ui/spinner"

export const AuthLoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background" role="status" aria-label="Loading">
    <Spinner className="size-8" />
  </div>
)
